import React, { useEffect, useRef, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
// import styles 
import "./footer.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faFacebookMessenger, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';

const divsToUpdate = document.querySelectorAll(".boilerplate-update-me-footer");

divsToUpdate.forEach((div) => {
  const data = JSON.parse(div.querySelector("pre").innerText);
  ReactDOM.render(<Footer {...data} />, div);
  div.classNameList.remove("boilerplate-update-me-footer");
});

function Footer() {

    return(
<div className="site-footer">
  <div className="container">
    <div className="row">
      <div className="col-sm-12 col-md-6">
        <h6>Über uns</h6>
        <p className="text-justify"> 
        Die Immogain GmbH wurde am 27.02.2007 von ihrem Inhaber und alleinigen Geschäftsführer Frank Böhme gegründet. Zu Anfang beschränkte sich die Geschäftstätigkeit auf den klassischen Immobilienhandel. Dazu gehören der Ankauf, die Wertsteigerung der erworbenen Liegenschaften sowie die Weitervermarktung. Unsere
Firmengeschichte lässt auf über 500 gekaufte Immobilien zurückblicken.
2016 wurde mit dem Bau eigener Neubauprojekte begonnen. Wir befassen uns seitdem vordergründig mit der Bauland- und Projektentwicklung einschließlich der gesamten Erschließung, sowie der daraus resultierenden Bauträgertätigkeit. Das heißt, wir erwerben Grundstücke, projektieren hierfür Wohnhäuser sowie Wohnanlagen und bauen und vermarkten diese dann in eigener Regie.

        </p>
      </div>

      <div className="col-xs-6 col-md-3">
        <h6>Unsere Fachgebiete</h6>
        <ul className="footer-links">
          <li><a href="#makler2">Maklertätigkeit</a></li>
          <li><a href="#makler3">Leistungen für Privatkunden</a></li>
          <li><a href="#makler3">Leistungen für Kreditinstitute</a></li>
          <li><a href="#bautraeger">Bauträger</a></li>
        </ul>
      </div>

      <div className="col-xs-6 col-md-3">
        <h6>Links</h6>
        <ul className="footer-links">
          <li><a href="../#about">Über uns</a></li>
          <li><a href="../#kontakt">Kontakt</a></li>
          <li><a href="../#kontakt-formular">Kontaktformular</a></li>
          <li><a href="../referenzobjekte">Referenzobjekte</a></li>
          <li><a href="../datenschutz">Datenschutzerlärung</a></li>
          <li><a href="../impressum">Impressum</a></li>
        </ul>
      </div>
    </div>

  </div>
  <div className="container">
    <div className="row">
      <div className="col-md-8 col-sm-6 col-xs-12">
        <p className="copyright-text">Copyright &copy; 2024 All Rights Reserved by 
     <a href="/">&nbsp; Immogain</a>.
        </p>
      </div>

      <div className="col-md-4 col-sm-6 col-xs-12">
        <ul className="social-icons">
          <li><a className="facebook" href="https://www.facebook.com/Immogain/">  <FontAwesomeIcon icon={faFacebook} size="2x" /></a></li>
          <li><a className="instagram" href="https://www.instagram.com/immogain/">  <FontAwesomeIcon icon={faInstagram} size="2x" /></a></li>
          <li><a className="youtube" href="https://www.youtube.com/watch?v=LKPlmPszWrw&feature=youtu.be">  <FontAwesomeIcon icon={faYoutube} size="2x" /></a></li>
          <li><a className="email" href="mailto:info@immogain.de">  <FontAwesomeIcon icon={faEnvelope} size="2x" /></a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
);
}


export default Footer;